export const parseEnvRanges = (rangesEnvString: string): number[][] => {
  return rangesEnvString.split("|").map((range) => {
    return range.split("/").map((elem) => parseInt(elem));
  });
};
